module.exports = __webpack_public_path__ + "static/logo-white-16cf7407a53b33aa8f5d112b12c4bf14.png";